module.exports = __webpack_public_path__ + "static/img/booking-btn.6b6df48.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion-h5/booking-btn.gif
// module id = Ywzd
// module chunks = 2